import { $api } from 'api/http'
import { IProductAmount, IProduct } from 'api/types/product'

class CartApiService {
  getCart() {
    return $api.get<Array<IProduct>>('/cart')
  }
  setAmount({ id, amount, price }: IProductAmount) {
    return $api.post<Array<IProduct>>('/cart', { id, amount, price })
  }
}

export const cartApiService = new CartApiService()
